export default __webpack_public_path__ + "static/network-3-77246c389ada58634f393e72378d6913.png";